import clsx from "clsx";

import NavItem from "features/layout/components/NavItem";

import { Tag } from "common/components/ui/Tag";

import type { JSX, ReactNode } from "react";

const desktopBadgeClassName =
  "rounded-md border items-center border-purple-200 bg-purple-100 text-button-xxs justify-center text-purple-600";

export default function NotificationNavItem({
  children,
  icon,
  isExpanded,
  isActive,
  notificationsCount,
}: {
  children: ReactNode;
  icon: JSX.Element;
  isExpanded: boolean;
  isActive: boolean;
  notificationsCount: number;
}) {
  return (
    <NavItem
      icon={
        <div className="relative">
          {icon}
          {!isExpanded && (
            <div
              className={clsx(
                "flex absolute -top-1.5 -right-1.5 size-3.5",
                desktopBadgeClassName,
              )}
            >
              {notificationsCount}
            </div>
          )}
          <div className="absolute lg:hidden rounded-full border bg-purple-500 border-white right-px top-0 size-2" />
        </div>
      }
      isActive={isActive}
      isExpanded={isExpanded}
    >
      {children}
      <Tag variant="secondary" className="ml-auto lg:hidden">
        {notificationsCount}
      </Tag>
      {isExpanded && (
        <div
          className={clsx(
            "hidden lg:flex h-4 min-w-4 ml-auto px-1",
            desktopBadgeClassName,
          )}
        >
          {notificationsCount}
        </div>
      )}
    </NavItem>
  );
}
